import { Component, AfterViewInit, Output, EventEmitter, forwardRef, ContentChildren, QueryList } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { Subject } from 'rxjs';

import { ButtonToggleItemComponent } from './button-toggle-item/button-toggle-item.component';

@Component({
  selector: 'artemis-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: ['./button-toggle.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ButtonToggleComponent),
    multi: true
  }]
})
export class ButtonToggleComponent implements AfterViewInit, ControlValueAccessor {

  @Output() change: EventEmitter<string> = new EventEmitter<string>();
  disabled: boolean = false;
  completed: Subject<any> = new Subject();
  private currentValue: any;

  onChange: (data: any) => void;
  onTouched: () => void;

  @ContentChildren(ButtonToggleItemComponent) items: QueryList<ButtonToggleItemComponent>;

  ngAfterViewInit() {
    this.items.forEach(e => {
      e.attach(this);
    });
    this.items.changes.subscribe((i: QueryList<ButtonToggleItemComponent>) => {
      i.forEach(e => {
        e.attach(this);
      });
    });
  }

  changeToggle(value: any) {
    if (value !== this.currentValue) {
      this.currentValue = value;
      this.writeValue(value);
      this.change.emit(this.currentValue);
      // deactive the rest
      this.completed.next(value);
    }
  }

  writeValue(value: string) {
    this.currentValue = value;
    if (this.currentValue !== null) {
      this.completed.next(value);
    }
    if (this.onChange) {
      this.onChange(value);
    }
  }


  registerOnChange(fn: any) {
    this.onChange = fn;
  }


  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.items.forEach(i => i.disable(isDisabled));
  }

}
